jQuery(document).foundation();

var $ = jQuery;

$(function() {
  $('.lazy').lazy({
    effect: "fadeIn",
    effectTime: 1500,
    threshold: 0
  });
});


WebFont.load({
  google: {
    families: ['Montserrat:400,500,700']
  }
});

/*
A simple jQuery function that can add listeners on attribute change.
http://meetselva.github.io/attrchange/
*/

!function(t){var e=window.MutationObserver||window.WebKitMutationObserver;t.fn.attrchange=function(a){var n={trackValues:!1,callback:t.noop};if("function"==typeof a?n.callback=a:t.extend(n,a),n.trackValues&&t(this).each(function(e,a){for(var n,i={},r=(e=0,a.attributes),l=r.length;e<l;e++)i[(n=r.item(e)).nodeName]=n.value;t(this).data("attr-old-value",i)}),e){var i={subtree:!1,attributes:!0,attributeOldValue:n.trackValues},r=new e(function(e){e.forEach(function(e){var a=e.target;n.trackValues&&(e.newValue=t(a).attr(e.attributeName)),n.callback.call(a,e)})});return this.each(function(){r.observe(this,i)})}return function(){var t=document.createElement("p"),e=!1;if(t.addEventListener)t.addEventListener("DOMAttrModified",function(){e=!0},!1);else{if(!t.attachEvent)return!1;t.attachEvent("onDOMAttrModified",function(){e=!0})}return t.setAttribute("id","target"),e}()?this.on("DOMAttrModified",function(t){t.originalEvent&&(t=t.originalEvent),t.attributeName=t.attrName,t.oldValue=t.prevValue,n.callback.call(this,t)}):"onpropertychange"in document.body?this.on("propertychange",function(e){e.attributeName=window.event.propertyName,function(e,a){if(e){var n=this.data("attr-old-value");if(a.attributeName.indexOf("style")>=0){n.style||(n.style={});var i=a.attributeName.split(".");a.attributeName=i[0],a.oldValue=n.style[i[1]],a.newValue=i[1]+":"+this.prop("style")[t.camelCase(i[1])],n.style[i[1]]=a.newValue}else a.oldValue=n[a.attributeName],a.newValue=this.attr(a.attributeName),n[a.attributeName]=a.newValue;this.data("attr-old-value",n)}}.call(t(this),n.trackValues,e),n.callback.call(this,e)}):this}}(jQuery);
// easing min.js

(function(factory){if(typeof define==="function"&&define.amd){define(["jquery"],function($){return factory($)})}else if(typeof module==="object"&&typeof module.exports==="object"){exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.easing.jswing=$.easing.swing;var pow=Math.pow,sqrt=Math.sqrt,sin=Math.sin,cos=Math.cos,PI=Math.PI,c1=1.70158,c2=c1*1.525,c3=c1+1,c4=2*PI/3,c5=2*PI/4.5;function bounceOut(x){var n1=7.5625,d1=2.75;if(x<1/d1){return n1*x*x}else if(x<2/d1){return n1*(x-=1.5/d1)*x+.75}else if(x<2.5/d1){return n1*(x-=2.25/d1)*x+.9375}else{return n1*(x-=2.625/d1)*x+.984375}}$.extend($.easing,{def:"easeOutQuad",swing:function(x){return $.easing[$.easing.def](x)},easeInQuad:function(x){return x*x},easeOutQuad:function(x){return 1-(1-x)*(1-x)},easeInOutQuad:function(x){return x<.5?2*x*x:1-pow(-2*x+2,2)/2},easeInCubic:function(x){return x*x*x},easeOutCubic:function(x){return 1-pow(1-x,3)},easeInOutCubic:function(x){return x<.5?4*x*x*x:1-pow(-2*x+2,3)/2},easeInQuart:function(x){return x*x*x*x},easeOutQuart:function(x){return 1-pow(1-x,4)},easeInOutQuart:function(x){return x<.5?8*x*x*x*x:1-pow(-2*x+2,4)/2},easeInQuint:function(x){return x*x*x*x*x},easeOutQuint:function(x){return 1-pow(1-x,5)},easeInOutQuint:function(x){return x<.5?16*x*x*x*x*x:1-pow(-2*x+2,5)/2},easeInSine:function(x){return 1-cos(x*PI/2)},easeOutSine:function(x){return sin(x*PI/2)},easeInOutSine:function(x){return-(cos(PI*x)-1)/2},easeInExpo:function(x){return x===0?0:pow(2,10*x-10)},easeOutExpo:function(x){return x===1?1:1-pow(2,-10*x)},easeInOutExpo:function(x){return x===0?0:x===1?1:x<.5?pow(2,20*x-10)/2:(2-pow(2,-20*x+10))/2},easeInCirc:function(x){return 1-sqrt(1-pow(x,2))},easeOutCirc:function(x){return sqrt(1-pow(x-1,2))},easeInOutCirc:function(x){return x<.5?(1-sqrt(1-pow(2*x,2)))/2:(sqrt(1-pow(-2*x+2,2))+1)/2},easeInElastic:function(x){return x===0?0:x===1?1:-pow(2,10*x-10)*sin((x*10-10.75)*c4)},easeOutElastic:function(x){return x===0?0:x===1?1:pow(2,-10*x)*sin((x*10-.75)*c4)+1},easeInOutElastic:function(x){return x===0?0:x===1?1:x<.5?-(pow(2,20*x-10)*sin((20*x-11.125)*c5))/2:pow(2,-20*x+10)*sin((20*x-11.125)*c5)/2+1},easeInBack:function(x){return c3*x*x*x-c1*x*x},easeOutBack:function(x){return 1+c3*pow(x-1,3)+c1*pow(x-1,2)},easeInOutBack:function(x){return x<.5?pow(2*x,2)*((c2+1)*2*x-c2)/2:(pow(2*x-2,2)*((c2+1)*(x*2-2)+c2)+2)/2},easeInBounce:function(x){return 1-bounceOut(1-x)},easeOutBounce:bounceOut,easeInOutBounce:function(x){return x<.5?(1-bounceOut(1-2*x))/2:(1+bounceOut(2*x-1))/2}})});

!function(){function e(){var e=!1;e&&c("keydown",o),g.keyboardSupport&&!e&&u("keydown",o)}function t(){if(document.body){var t=document.body,r=document.documentElement,a=window.innerHeight,o=t.scrollHeight;if(x=document.compatMode.indexOf("CSS")>=0?r:t,w=t,e(),S=!0,top!=self)y=!0;else if(o>a&&(t.offsetHeight<=a||r.offsetHeight<=a)&&(r.style.height="auto",x.offsetHeight<=a)){var n=document.createElement("div");n.style.clear="both",t.appendChild(n)}g.fixedBackground||b||(t.style.backgroundAttachment="scroll",r.style.backgroundAttachment="scroll")}}function r(e,t,r,a){if(a||(a=1e3),d(t,r),1!=g.accelerationMax){var o=+new Date,n=o-T;if(n<g.accelerationDelta){var i=(1+30/n)/2;i>1&&(i=Math.min(i,g.accelerationMax),t*=i,r*=i)}T=+new Date}if(M.push({x:t,y:r,lastX:0>t?.99:-.99,lastY:0>r?.99:-.99,start:+new Date}),!C){var l=e===document.body,u=function(){for(var o=+new Date,n=0,i=0,c=0;c<M.length;c++){var s=M[c],d=o-s.start,f=d>=g.animationTime,p=f?1:d/g.animationTime;g.pulseAlgorithm&&(p=h(p));var m=s.x*p-s.lastX>>0,w=s.y*p-s.lastY>>0;n+=m,i+=w,s.lastX+=m,s.lastY+=w,f&&(M.splice(c,1),c--)}l?window.scrollBy(n,i):(n&&(e.scrollLeft+=n),i&&(e.scrollTop+=i)),t||r||(M=[]),M.length?E(u,e,a/g.frameRate+1):C=!1};E(u,e,0),C=!0}}function a(e){S||t();var a=e.target,o=l(a);if(!o||e.defaultPrevented||s(w,"embed")||s(a,"embed")&&/\.pdf/i.test(a.src))return!0;var n=e.wheelDeltaX||0,i=e.wheelDeltaY||0;return n||i||(i=e.wheelDelta||0),!g.touchpadSupport&&f(i)?!0:(Math.abs(n)>1.2&&(n*=g.stepSize/120),Math.abs(i)>1.2&&(i*=g.stepSize/120),r(o,-n,-i),void e.preventDefault())}function o(e){var t=e.target,a=e.ctrlKey||e.altKey||e.metaKey||e.shiftKey&&e.keyCode!==H.spacebar;if(/input|textarea|select|embed/i.test(t.nodeName)||t.isContentEditable||e.defaultPrevented||a)return!0;if(s(t,"button")&&e.keyCode===H.spacebar)return!0;var o,n=0,i=0,u=l(w),c=u.clientHeight;switch(u==document.body&&(c=window.innerHeight),e.keyCode){case H.up:i=-g.arrowScroll;break;case H.down:i=g.arrowScroll;break;case H.spacebar:o=e.shiftKey?1:-1,i=-o*c*.9;break;case H.pageup:i=.9*-c;break;case H.pagedown:i=.9*c;break;case H.home:i=-u.scrollTop;break;case H.end:var d=u.scrollHeight-u.scrollTop-c;i=d>0?d+10:0;break;case H.left:n=-g.arrowScroll;break;case H.right:n=g.arrowScroll;break;default:return!0}r(u,n,i),e.preventDefault()}function n(e){w=e.target}function i(e,t){for(var r=e.length;r--;)z[N(e[r])]=t;return t}function l(e){var t=[],r=x.scrollHeight;do{var a=z[N(e)];if(a)return i(t,a);if(t.push(e),r===e.scrollHeight){if(!y||x.clientHeight+10<r)return i(t,document.body)}else if(e.clientHeight+10<e.scrollHeight&&(overflow=getComputedStyle(e,"").getPropertyValue("overflow-y"),"scroll"===overflow||"auto"===overflow))return i(t,e)}while(e=e.parentNode)}function u(e,t,r){window.addEventListener(e,t,r||!1)}function c(e,t,r){window.removeEventListener(e,t,r||!1)}function s(e,t){return(e.nodeName||"").toLowerCase()===t.toLowerCase()}function d(e,t){e=e>0?1:-1,t=t>0?1:-1,(k.x!==e||k.y!==t)&&(k.x=e,k.y=t,M=[],T=0)}function f(e){if(e){e=Math.abs(e),D.push(e),D.shift(),clearTimeout(A);var t=D[0]==D[1]&&D[1]==D[2],r=p(D[0],120)&&p(D[1],120)&&p(D[2],120);return!(t||r)}}function p(e,t){return Math.floor(e/t)==e/t}function m(e){var t,r,a;return e*=g.pulseScale,1>e?t=e-(1-Math.exp(-e)):(r=Math.exp(-1),e-=1,a=1-Math.exp(-e),t=r+a*(1-r)),t*g.pulseNormalize}function h(e){return e>=1?1:0>=e?0:(1==g.pulseNormalize&&(g.pulseNormalize/=m(1)),m(e))}var w,v={frameRate:150,animationTime:1800,stepSize:85,pulseAlgorithm:!0,pulseScale:8,pulseNormalize:1,accelerationDelta:20,accelerationMax:1,keyboardSupport:!0,arrowScroll:50,touchpadSupport:!0,fixedBackground:!0,excluded:""},g=v,b=!1,y=!1,k={x:0,y:0},S=!1,x=document.documentElement,D=[120,120,120],H={left:37,up:38,right:39,down:40,spacebar:32,pageup:33,pagedown:34,end:35,home:36},g=v,M=[],C=!1,T=+new Date,z={};setInterval(function(){z={}},1e4);var A,N=function(){var e=0;return function(t){return t.uniqueID||(t.uniqueID=e++)}}(),E=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||function(e,t,r){window.setTimeout(e,r||1e3/60)}}(),K=/chrome/i.test(window.navigator.userAgent),L="onmousewheel"in document;L&&K&&(u("mousedown",n),u("mousewheel",a),u("load",t))}();


$(document).mousemove(function (e) {
    $(".moveBlock").parallax(-30, e);
});

$.fn.parallax = function (resistance, mouse) {
    $el = $(this);
    TweenLite.to($el, 0.2, {
        x: -((mouse.clientX - window.innerWidth / 2) / resistance),
        y: -((mouse.clientY - window.innerHeight / 2) / resistance)
    });
};

$(document).ready(function(){ 
	$('.featured-sliders').slick({
		dots: true,
		// fade: true,
		cssEase: 'ease-in-out',
		arrows:false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1
	});
	 $('.counter').counterUp({
        delay: 10,
        time: 1000
    });
	$('.loc-slider, .rel-slider, .interior-slider').slick({
		nextArrow: $('.slick-next-arrow'),
		prevArrow: $('.slick-prev-arrow'),
		cssEase:"ease-in-out",
		infinite:false,
		slidesToShow:3,
		slidesToScroll:1,
		lazyLoad:"progressive",
		speed:301,
		touchThreshold:10,
		responsive: [
		  {
		    breakpoint: 900,
		    settings: {
		      slidesToShow: 2,
		      slidesToScroll: 1,
		    }
		  },
		  {
		    breakpoint: 600,
		    settings: {
		      slidesToShow: 2,
		      slidesToScroll: 1,
		      arrows:false,
		      dots: true
		    }
		  },
		  {
		    breakpoint: 480,
		    settings: {
		      slidesToShow: 1,
		      slidesToScroll: 1,
		      arrows:false,
		      dots: true
		    }
		  }
		]
	});
    $('.landscape-slider').slick({
    nextArrow: $('.slick-next-arrow-land'),
    prevArrow: $('.slick-prev-arrow-land'),
    cssEase:"ease-in-out",
    infinite:false,
    slidesToShow:3,
    slidesToScroll:1,
    lazyLoad:"progressive",
    speed:301,
    touchThreshold:10,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          dots: true
        }
      }
    ]
  });
});

$('.loc-slider, .rel-slider, .interior-slider, .landscape-slider').on('beforeChange', function(event, slick, current){
	$(this).find(slick.$slides.get(current)).addClass("slide-hide");
	$(this).find(".slick-current").prevAll().addClass("slide-hide");
	$(this).find(".slick-current").nextAll().removeClass("slide-hide");
});

jQuery(function($) {
   var $images = $('.entry-content-post img');
   if ($images.length > 0) {
     //console.log($images);
     $images.wrap( "<div class='imageblock'></div>" );
    }
});

$(document).ready(function() {
  // if ($("#ytvmodelID").length){
  //     videoid = $("#ytvmodelID").attr("data-videoId")
  // } else {
  //    videoid = 'w5MzQ59Y3OE';
  // }
  if ($("#setProject").length){
      var projectName = $("#setProject").attr("data-project");
      $("#projectName").val(projectName);
  }

});

document.addEventListener("DOMContentLoaded",
  function() {
    try {
    var div, n,
        v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.innerHTML = ytvPThumb(v[n].dataset.id);
        div.onclick = ytvPIframe;
        v[n].appendChild(div);
    }
    }
    catch(err) {
      console.log(err);
    }
 });
function ytvPThumb(id) {
  try {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
        play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play;
  }
  catch(err) {
      console.log('Youtube Blocked' + err);
  }    
}
  function ytvPIframe() {
      var iframe = document.createElement("iframe");
      var embed = "https://www.youtube.com/embed/ID?enablejsapi=1&version=3&playerapiid=ytplayer&rel=0";
      iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "1");
      this.parentNode.replaceChild(iframe, this);
}
// var player, videoid;
// Youtube Player
// $("#ytvmodelID").on('click', function(){
// var tag = document.createElement('script');
// tag.src = "https://www.youtube.com/iframe_api";
// var firstScriptTag = document.getElementsByTagName('script')[0];
// firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// function onYouTubeIframeAPIReady() {
//     player = new YT.Player('yt_player', {
//         height: '500',
//         width: '100%',
//         videoId: videoid,
//         playerVars: {rel: 0},
//         events: {
//             'onStateChange': onPlayerStateChange
//         }
//     });
// }
// function onPlayerStateChange(event) {
//     if (event.data == YT.PlayerState.PLAYING) {
//       //player is playing
//     } else {
//       //player is paused
//     }
// }

// function playVideo() {
//   player.playVideo();
// }

// function pauseVideo() {
//   player.pauseVideo();
// }
// });

function setBannerHeight() {
  var bannerheight = $('.featured-sliders').outerHeight();
  $(".static-image").css("height", bannerheight +"px");
}
window.addEventListener('load', setBannerHeight); 
window.addEventListener('resize', setBannerHeight);

// $(document).on('open.zf.reveal', '#ytv_model', function() {
// 	playVideo();
// });

$(document).on('closed.zf.reveal', '#ytv_model', function() {
	$('.youtube-player iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
});

$(document).ready(function() {
	$(".btn-menu").on('click', function(){
		$(".dropdown-menu").slideToggle("fast");
	});
});

// var slideWrapper = $(".project-slides"),
//     iframes = slideWrapper.find('.embed-player');
//     // lazyImages = slideWrapper.find('.slide-image'),
//     // lazyCounter = 0;

// // POST commands to YouTube or Vimeo API
// function postMessageToPlayer(player, command){
//   if (player == null || command == null) return;
//   player.contentWindow.postMessage(JSON.stringify(command), "*");
// }

// // When the slide is changing
// function playPauseVideo(slick, control){
//   var currentSlide, slideType, startTime, player, video;

//   currentSlide = slick.find(".slick-current");
//   slideType = currentSlide.attr("class").split(" ")[1];
//   player = currentSlide.find("iframe").get(0);
//   startTime = currentSlide.data("video-start");

// if (slideType === "youtube") {
//     switch (control) {
//       case "play":
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "mute"
//         });
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "playVideo"
//         });
//         break;
//       case "pause":
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "pauseVideo"
//         });
//         break;
//     }
//   } 
// }

// // Resize player
// function resizePlayer(iframes, ratio) {
//   if (!iframes[0]) return;
//   var win = $(".image-slider"),
//       width = win.width(),
//       playerWidth,
//       height = win.height(),
//       playerHeight,
//       ratio = ratio || 16/9;

//   iframes.each(function(){
//     var current = $(this);
//     if (width / ratio < height) {
//       playerWidth = Math.ceil(height * ratio);
//       current.width(playerWidth).height(height).css({
//         left: (width - playerWidth) / 2,
//          top: 0
//         });
//     } else {
//       playerHeight = Math.ceil(width / ratio);
//       current.width(width).height(playerHeight).css({
//         left: 0,
//         top: (height - playerHeight) / 2
//       });
//     }
//   });
// }

// DOM Ready
$(function() {
  // Initialize
  // slideWrapper.on("init", function(slick){
  //   slick = $(slick.currentTarget);
  //   setTimeout(function(){
  //     playPauseVideo(slick,"play");
  //   }, 1000);
  //   resizePlayer(iframes, 16/9);
  // });
  // slideWrapper.on("beforeChange", function(event, slick) {
  //   slick = $(slick.$slider);
  //   playPauseVideo(slick,"pause");
  // });
  // slideWrapper.on("afterChange", function(event, slick) {
  //   slick = $(slick.$slider);
  //   playPauseVideo(slick,"play");
  // });
  // // slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
  // //   lazyCounter++;
  // //   if (lazyCounter === lazyImages.length){
  // //     lazyImages.addClass('show');
  // //     // slideWrapper.slick("slickPlay");
  // //   }
  // // });

  // //start the slider
  // slideWrapper.slick({
  //   // fade:true,
  //   autoplaySpeed:4000,
  //   lazyLoad:"progressive",
  //   speed:600,
  //   arrows:false,
  //   dots:false,
  //   cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
  //   asNavFor: '.project-navs'
  // });

  // $('.project-navs').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   asNavFor: '.project-slides',
  //   dots: false,
  //   focusOnSelect: true,
  //   draggable:true

  // });

  lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
      })
});

$(function(){
      // bind change event to select
      $('[id="projectType"]').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
    });
// Resize event
// $(window).on("resize.slickVideoPlayer", function(){  
//   resizePlayer(iframes, 16/9);
// });

// This will let you use the .remove() function later on


// Tools

$('input[class="areainput"]').change(function () {
  console.log(this);
    this.value = parseFloat(this.value);
    if (isNaN(this.value))
        this.value = 1;
    var t = $(this).attr('opt-val')
    calcMeasures(this.value / factor[t]);

});
$('#reset').click(function () {
$('input[class="areainput"]').val('');
});
var factor = []
factor[1] = 1;      //sq.ft
factor[2] = 0.0930000000000; //sq.mts
//      factor[3] = 0.1111111111111; //sq.yards
factor[3] = 0.00002295663; //acres  
factor[5] = 0.0000092904166; //hectares 
factor[4] = 0.002296; //cent    
factor[6] = 0.00092936802973; //are

function calcMeasures(value) {
    calc($('#txtSqrFt'), value, 1);
    calc($('#txtMetre'), value, 3);
    calc($('#txtHect'), value, 5);
    calc($('#txtAcre'), value, 5);
    calc($('#txtAre'), value, 3);
    calc($('#txtCent'), value, 3);
}

function calc(obj, value, fix) {
    //  var pow = Math.pow(10, fix);
    obj.val((value.toFixed(fix) * factor[obj.attr('opt-val')]).toFixed(fix));
}

// Emi
$(function () {
 // $('.leinput').change(function () {
 //    this.value = parseFloat(this.value);
 //    if (isNaN(this.value))
 //      this.value = 1;
 //  });
  $('.lebutton').click(function () {
    calcLE();
    $('.leresults').slideDown();
  });
 });

 function calcLE() {
  var vami = $('#txtAPPgross').val();
  var vcmi = $('#txtCoAPPgross').val();
  var votl = $('#txtOthLoan').val();
  var votd = $('#txtDed').val();
  var vintr = $('#txtInterest').val();
  var vmtor = $('#txtLoanTenure').val();
  vtotin = (parseInt(vami) + parseInt(vcmi)) - (parseInt(votl) + parseInt(votd));
  vemi = calcEmi(100000, vintr, vmtor);
  vmaxloan = (vtotin * (0.4) / (vemi));
  var tt = Math.ceil(vemi);
  tt = (isNaN(tt)) ? 0.0 : tt;
  $('#txtEmi').val(tt + " per Lakh");
  vmaxloan = vmaxloan * 100;
  vmaxloan = Math.round(vmaxloan);
  vmaxloan = vmaxloan / 100;
  vmaxloan = (isNaN(vmaxloan)) ? 0.0 : vmaxloan;
  $('#txtEligibleLoan').val(vmaxloan + " Lakhs");
}
function calcEmi(vAmt, vintr, vmtor) {
  var terms;
  var numAmt, denAmt;
  var emiv;
  terms = 12;
  numAmt = vAmt * Math.pow((1 + vintr / (terms * 100)), vmtor);
  denAmt = 100 * terms * (Math.pow((1 + vintr / (terms * 100)), vmtor) - 1) / vintr;
  emiv = 12 * (numAmt / (denAmt * 12));
  emiv = Math.round(emiv);
  return emiv;
}
// Clickable Div
$(".feat-project, .projectfeatimage").click(function() {
  window.location = $(this).find("a").attr("href"); 
  return false;
});

$(document).ready(function(){
  var prevHeight = $('.sidebar-contact').outerHeight();
  $(".sidebar-contact").css("top", '-'+ prevHeight +"px");
  $('.sidebar-contact').attrchange({
    callback: function (e) {
      var curHeight = $(this).outerHeight();            
      if (prevHeight !== curHeight) {
        console.log('height changed from ' + prevHeight + ' to ' + curHeight);
        prevHeight = curHeight;
        $(".sidebar-contact").css("top", '-'+ prevHeight +"px");
      }            
    }
  });
  $('.toggle-button').click(function(){
    $('.sidebar-contact').toggleClass('active');
    $('.toggle-button').toggleClass('active');
  });


  $(".readMorebox").click(function() {
    $('.catAboutbox').toggleClass('actualHeight');
  });
})

document.addEventListener( 'wpcf7mailsent', function( event ) {
  if ( '380' == event.detail.contactFormId ) {
    dataLayer.push({'event': 'projectsquickenquiryform'});
  }
  else if ( '305' == event.detail.contactFormId ) {
    dataLayer.push({'event': 'contactusform'});
  }
  else if ( '33' == event.detail.contactFormId ) {
    dataLayer.push({'event': 'newsletterfooterform'});
  }
  else if ( '1252' == event.detail.contactFormId ) {
    dataLayer.push({'event': 'quickenquirystickyform'});
  }
}, false );

